import request from '@/utils/request'

export const getCurrencyList = () => request.get('/masterdata-api/rate/list')
export const getCreditanalystsList = () =>
  request.get('/masterdata-api/user/creditanalysts/list')

// 获取所有客户信息
export const getCustomerInfo = id =>
  request.get(`/customer-api/customer/query/${id}`)
// 获取credit History
export const getDescTran = id =>
  request.get(`/workflow-api/credit-apply/approve/desc/${id}`)

// 更新或者修改用户基本信息
export const addOrUpdateBaseInfo = params =>
  request.post('/customer-api/customer/add', params)
// 更新或者修改 External Reference Information
export const addOrUpdateExternalInfo = params =>
  request.post('/customer-api/customer/external/add', params)

// 更新或者修改 Account
export const addOrUpdateAccountInfo = params =>
  request.post('/customer-api/customer/account/add', params)

// 更新或者修改 Eaas
export const addOrUpdateEaasInformation = params =>
  request.post('/customer-api/customer/updateEaasInfo', params)

// 更新或者修改 Japan
export const addOrUpdateJapanInfo = params =>
  request.post('/customer-api/customer/japan/add', params)

// 更新或者修改 detail
export const addOrUpdateDetailInfo = params =>
  request.post('/customer-api/customer/detail/add', params)
// 更新或者修改 business
export const addOrUpdateBusinessInfo = params =>
  request.post('/customer-api/businesscontacts/add', params)

export const getParentNameList = companyId =>
  request.get(
    `/customer-api/company-relation/relation/children/${companyId}/parent`,
  )
// 查询active name
export const vagueActiveName = () =>
  request.get(`/masterdata-api/user/active/query/`)

export const getStateSelectList = id =>
  request.get(`/masterdata-api/valuelist/State/${id}`)
